export default __webpack_public_path__ + "static/media/embedded.0931ba54.jpg";